@import "~@swisscom/sdx/stylesheets/sdx/variables/colors";
@import "~@swisscom/sdx/stylesheets/sdx/variables/sizes";
@import "~@swisscom/sdx/stylesheets/sdx/variables/grid";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/breakpoints";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/mediaqueries";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/typography";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/text";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/misc";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/core";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/gradient";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/button";
@import "~@swisscom/sdx/stylesheets/sdx/variables/global";
@import "~@swisscom/sdx/stylesheets/sdx/button/button";
@import "~@swisscom/sdx/stylesheets/sdx/typography/typography";
@import "~@swisscom/sdx/stylesheets/sdx/css-variables-tokens-desktop";
@import "~@swisscom/sdx/stylesheets/sdx/css-variables-tokens-functional-and-mobile";

:host {
  --pf-flap-width-px: 1126px;
  --pf-flap-margin-x: 0px;
}

.pf-wrapper {
  position: relative;
}

.para-flap {
  position: relative;
  bottom: 96px;
  z-index: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  left: 50%;
  transform: translateX(-50%);

  /* Subtract 2 * gutter from the viewport constraint so the flap shows side "margins" */
  width: min(
    var(--pf-flap-width-px),
    calc(100vw - (2 * var(--pf-flap-margin-x))),
    1440px
  );

  min-height: 272px;
  border-radius: var(--sdx-border-radius-xlarge) var(--sdx-border-radius-xlarge)
    0 0;

  overflow: hidden;
  box-sizing: border-box;
  padding: 24px 32px;

  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 1) 100%
  );

  -webkit-backdrop-filter: blur(80px);
  backdrop-filter: blur(80px);

  .pf-content {
    max-width: 1078px;
    left: 50%;
    transform: translate(-50%, 0);
    position: relative;
  }

  p,
  h1 {
    text-align: center;
  }
  p {
    color: $color-gray;
  }
}

@media (prefers-reduced-motion: reduce) {
  .para-flap {
    width: min(
      var(--pf-flap-width-px),
      calc(100vw - (2 * var(--pf-flap-margin-x))),
      1440px
    );
  }
}
